module.exports = __webpack_public_path__ + "img/fundo-grid-allsTech.0319f855.svg";